export interface riskCategory {
  id: number;
  name: String;
}
export const riskCategorys: riskCategory[] = [
  {
    id: 0,
    name: 'NO APLICA',
  },
  {
    id: 1,
    name: 'CASAS DE CAMBIO NO DOMICILIADAS EN EL PAÍS',
  },
  {
    id: 2,
    name: 'EMPRESA DEDICADA A LA TRANSFERENCIA O ENVIO DE FONDOS O REMESAS',
  },
  {
    id: 3,
    name: 'CASINOS Y SALAS DE JUEGO',
  },
  {
    id: 4,
    name: 'PRESTAMISTAS',
  },
  {
    id: 5,
    name: 'OPERADORES CAMBIARIOS FRONTERIZOS',
  },
  {
    id: 6,
    name: 'CASAS DE EMPEÑO',
  },
  {
    id: 7,
    name: "ASOCIACIONES CIVILES SIN FINES DE LUCRO, FUNDACIONES U ORGANISMOS NO GUBERNAMENTALES (ONG'S)",
  },
  {
    id: 8,
    name: 'INVERSIONISTAS Y AGENCIAS DE BIENES RAICES',
  },
  {
    id: 9,
    name: 'COMERCIALIZADORA Y ARRENDADORAS DE VEHICULOS AUTOMOTORES, EMBARCACIONES Y AERONAVES',
  },
  {
    id: 10,
    name: 'COMERCIALIZADORA DE ANTIGUEDADES, JOYAS, METALES Y PIEDRAS PRECIOSAS, MODENAS, OBJETOS DE ARTE Y SELLOS POSTALES',
  },
  {
    id: 11,
    name: 'COMERCIALIZADORES DE ARMAS, EXPLOSIVOS Y MUNICIONES.',
  },
  {
    id: 12,
    name: 'PERSONAS POLITICAMENTE EXPUESTAS (PEP) INCLUYENDO FAMILIARES CERCANOS, ASOCIADOS Y ESTRECHOS COLABORANTES',
  },
  {
    id: 13,
    name: 'ABOGADOS NOTARIOS, CONTADORES PUBLICOS Y OTROS PROFESIONALES INDEPENDIENTES',
  },
  {
    id: 14,
    name: 'PERSONAS JURIDICAS CONSTITUIDAS Y ESTABLECIDAS EN PARAISOS FISCALES (JURIDISCCIONES OFF SHORE)',
  },
];
